import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppResource } from 'src/app/app.resource';
import { Resource } from 'src/app/resources/resource';
import * as fromRoot from '../../../core/state/core.state';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit {
  title: string = 'ERROR 404';
  message: string = 'Le parcours de souscription auquel vous essayer d\'accéder est indisponible.';
  resource: Resource;

  constructor(
      private readonly store: Store<fromRoot.State>,
      protected resources: AppResource,
      private route: ActivatedRoute
    )
    {
      this.resource = resources['resource'];
       // Récupérer les données depuis les data de la route
      const routeData = this.route.snapshot.data;
      if (routeData['title']) {
        this.title = routeData['title'];
      }
      if (routeData['message']) {
        this.message = routeData['message'];
      }
    }

  ngOnInit() {}

}
